import { IAccountRecoveryState, IStore } from 'store/types';

export const selectAccountRecovery =
  () =>
  (state: IStore): IAccountRecoveryState =>
    state?.accountRecovery;
